export interface ILookupResult {
  label: string
  shortcut: string
  target: string
  href: string
  index?: number
  modal?: boolean
  additionalClasses?: { [key:string]: boolean }
}

export interface ISearchState {
  lookup: string
  results: ILookupResult[][]
  accessToken: string
  fundSearchApiEndpoint: string
  selectedResultIndex: number
  canResultPanelOpen: boolean
  cacheSuffix: string
  mustHaveCacheSuffix: boolean 
}

export type Timeout = any

export enum FundSearchHitKind {
  None,
  Both,
  Code,
  Name
}

export interface IFundSearchFund {
  code: string;
  name: string;
  businessCode: string;
  url: string;
  hitKind: FundSearchHitKind;
}

export interface IFundSearchResult {
  funds: IFundSearchFund[];
  searchString: string;
}

export interface IFundSearchRequest {
  searchString: string;
  page: number | null;
  pageSize: number | null;
}


export interface IMenuItem {
  caption: string
  actionUrl: string
  menuItems: IMenuItem[]
  target?: string
  modal?: boolean
}

export interface ISearchMenuItem {
  index: number
  caption: string
  menuItem: IMenuItem
}
